import { ResyncButtonWrapper } from "./ResyncButton";

import { registerCustomComponent } from "@/features/integrations/shared/renderer/components";

registerCustomComponent("resyncButton", ResyncButtonWrapper);
